import React, {useState, useEffect, createContext, useContext} from 'react';
import Icon from '../Icons/Icon';
import { Navigate } from 'react-router-dom';
import Callback from '../../Services/Callback';

const HelpContext = createContext();

export const useHelpContext = () => {
    return useContext(HelpContext);
};

const scrollHook = new Callback();

export default ({children}) => {

    const [openDoc, setOpenDoc] = useState(null);
    const [unreadMessages, setUnreadMessages] = useState(0);
    const [redirect, setRedirect] = useState(null);

    useEffect(() => {
        const current = window.location.href.replace(window.location.origin, '');
        const target = redirect?.replace(window.location.origin, '');

        if (current === target) {
            setRedirect(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href, redirect]);

    const docTrigger = (doc) => {
        return <span className="inline-block cursor-pointer fill-muted mx-3" onClick={() => setOpenDoc(doc)}>
            <Icon icon="CircleInfo" size="1x" />
        </span>
    }

    const providerValues = {
        showHelp: setOpenDoc,
        setOpenDoc,
        openDoc,
        unreadMessages,
        setUnreadMessages,
        docTrigger,
        redirect: setRedirect,
        scrollHook,
    };

    return <HelpContext.Provider value={providerValues}>
        {children}
        {redirect && <Navigate to={redirect} />}
    </HelpContext.Provider>
}

export {
    scrollHook,
}
